import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Checkbox,
  IconButton,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { Field, Form, Formik } from "formik";
import React from "react";
import * as Yup from "yup";
import Label from "./Label";
import PostScript from "./PostScript";

interface AdOnTextModalProps {
  open: boolean;
  handleClose: () => void;
  setFormValues: any;
  onSave: (values: any) => void;
}

const AdOnTextModal: React.FC<AdOnTextModalProps> = ({
  open,
  handleClose,
  setFormValues,
  onSave,
}) => {
  const initialValues = {
    type: 1,
    header: "",
    place_holder: "",
    description: "",
    price: "",
    required: false,
  };

  const formValidation = Yup.object().shape({
    header: Yup.string().required("Header is required"),
  });

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "#fff",
          p: 3,
          borderRadius: 2,
          boxShadow: 24,
          width: {
            xs: "80%", // small devices
            sm: "50%", // medium devices
            md: "30%", // large devices
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="h6" fontWeight={600}>
            Text Field
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Formik
          initialValues={initialValues}
          validationSchema={formValidation}
          onSubmit={(values) => {
            onSave(values);
            handleClose();
          }}
        >
          {({ values, errors, touched, handleChange, handleBlur }) => {
            return (
              <Form>
                <Box sx={{ marginY: "0px" }}>
                  <Label label="Header" required={true} />
                  <Field
                    as={TextField}
                    name="header"
                    fullWidth
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.header && Boolean(errors.header)}
                    inputProps={{
                      style: { fontSize: "14px", padding: "15px 10px" },
                    }}
                  />
                  {errors.header && touched.header && (
                    <Typography color="red" fontSize="12px">
                      {errors.header}
                    </Typography>
                  )}
                  <PostScript text="Ex: Do you have any allergies?" />
                </Box>

                <Box sx={{ marginY: "0px" }}>
                  <Label label="Placeholder text" required={false} />
                  <Field
                    as={TextField}
                    name="place_holder"
                    fullWidth
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.place_holder && Boolean(errors.place_holder)}
                    inputProps={{
                      style: { fontSize: "14px", padding: "15px 10px" },
                    }}
                  />
                  <PostScript text="This can help explain what kind of answer you are looking for a customer" />
                </Box>

                {/* Checkbox */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    border: "1px solid #8D8D8D",
                    alignItems: "center",
                    marginBottom: "10px",
                    borderRadius: "8px",
                    padding: "5px",
                    marginY: "10px",
                    gap: "5px",
                  }}
                >
                  <Checkbox
                    name="required"
                    checked={values.required}
                    onChange={handleChange}
                  />
                  <Typography
                    sx={{ fontSize: "13px", fontWeight: 400, color: "#000" }}
                  >
                    Check if this field is required for the customer
                  </Typography>
                </Box>

                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  sx={{
                    bgcolor: "#328734",
                    fontWeight: 600,
                    p: 1.5,
                    borderRadius: "8px",
                  }}
                >
                  Add Text Field Box
                </Button>
              </Form>
            );
          }}
        </Formik>
      </Box>
    </Modal>
  );
};

export default AdOnTextModal;
